import { render, staticRenderFns } from "./VaildEmail.vue?vue&type=template&id=41984b8c&scoped=true"
import script from "./VaildEmail.vue?vue&type=script&lang=js"
export * from "./VaildEmail.vue?vue&type=script&lang=js"
import style0 from "./VaildEmail.vue?vue&type=style&index=0&id=41984b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41984b8c",
  null
  
)

export default component.exports